import * as taskName from './task-name'
import { selectCustomer } from '../../../../customer/state/detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: taskName.CLARIFY_REMARKS,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectCustomer,
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, customer, context) => {
        const messageList = []
        const cannotBeTreatedReason = context.cannotBeTreatedReason
        if (!cannotBeTreatedReason && eventName === 'cannot_be_treated') {
            messageList.push(createValidationMessage("Please add the reason for 'cannot be treated' before proceeding.", 'checkDeliveryTracking.checkDeliveryTracking'))
            return messageList
        }

        // make sure at least one is true
        if (!customer.partnerPhysicianId && !customer.treatingPhysicianId) {
            messageList.push(createValidationMessage('Please select a physician.', 'validateAssignPhysician.physicianId'))
        }

        // make sure at least one is true
        if (!customer.partnerSupplierId && processInstance.processName !== 'process-implant-plan') {
            messageList.push(createValidationMessage('Please select a supplier', 'validateAssignPhysician.supplier'))
        }

        return messageList
    },
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/clarify-remarks.js